module.exports = __webpack_public_path__ + "assets/img/5900c5cbd54e93a6e801a2b996ef0919.png";